<template>
  <b-row align-h="between" class=" mt-3">
    <b-col cols="6" lg="3" align-self="start">
      <b-link class="pt-3 mt-2" @click="goBack">
        <font-awesome-icon :icon="['far', 'chevron-left']" fixed-width />
        <span class="fs-16">Atrás</span>
      </b-link>
    </b-col>
    <b-col align-self="center">
      <slot name="right">
        <div class="text-right">
          <b-button variant="primary" size="sm" @click="$emit('new-ticket')" class="mr-2">
            <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />
            <span>Solicitar Ticket</span>
          </b-button>
        </div>
      </slot>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'NavBar',
  methods: {
    goBack () {
      if (this.$route.name === 'TicketIndex') {
        this.$router.push('/')
      } else if (this.$route.name === 'TicketShow') {
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.push('/app/tickets')
        }
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>
